export default "__VITE_ASSET__vsbvPB_k__"